import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { GetPlayerQueueStatusOutput, WebAppRoutes } from "types/web-app";

export const getPlayerQueueStatus = async (
  token: string
): Promise<ServiceResponse<GetPlayerQueueStatusOutput>> => {
  const response = await fetchWithAuth(
    `/${WebAppRoutes.GET_PLAYER_QUEUE_STATUS}`,
    token,
    {
      method: "GET",
    }
  );

  return response.json();
};

